var Platform = {
  OS: 'web',
  select: function select(obj) {
    return obj.web;
  }
};
module.exports = Platform;